/**
 * Calculate the number of nights between two ISO date strings ("YYYY-MM-DD").
 *
 * Uses local-time arithmetic via `new Date(y, m-1, d)` to avoid UTC offset issues.
 * Returns 0 when startDate === endDate (same-day, 0 nights).
 */
export const calculateNights = (startDate: string, endDate: string): number => {
  const [sy, sm, sd] = startDate.split('-').map(Number);
  const [ey, em, ed] = endDate.split('-').map(Number);
  const start = new Date(sy, sm - 1, sd);
  const end = new Date(ey, em - 1, ed);
  const diffMs = end.getTime() - start.getTime();
  return Math.round(diffMs / (1000 * 60 * 60 * 24));
};
